export default __webpack_public_path__ + "static/media/Classwin_Menu-pop-up_1-Dashboard.997b2ff2.jpeg";